module.exports = __webpack_public_path__ + "html/relation-list_582b5e422b2dfc03de3622f1c50e85d9.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/relation-list.html
// module id = driL
// module chunks = 69